var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete20(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.29353 5.9284C10.356 8.4284 14.3092 14.8867 16.0279 17.8034H15.6764C7.43421 6.78779 2.47322 6.43621 1.10603 4.48309C-0.261158 2.52996 1.67262 0.92306 3.72322 1.35809C4.83429 1.5938 7.23884 4.47007 8.29353 5.9284Z",
    fill: "#E32B2B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.77377 10.3422C8.97995 8.17804 11.4964 6.12346 19.4652 4.09221L19.5824 4.40471C8.80112 7.88127 6.04988 16.4712 3.88858 17.7703C1.72728 19.0695 0.0463407 17.0812 0.583246 15.0467C0.874155 13.9443 2.5676 12.5064 5.77377 10.3422Z",
    fill: "#E32B2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete20);
export default __webpack_public_path__ + "static/media/delete_20.f63ae3c0f907e2d55b5b233ff55c8771.svg";
export { ForwardRef as ReactComponent };